import { toSvgDataUri } from './svg';

/**
 * Convertit un logo (SVG + recadrage/zoom, mêmes paramètres que LogoPreview)
 * en une image PNG plate, dessinée sur un <canvas>. Utilisé UNIQUEMENT par
 * l'export PDF (pdfExport.ts) : html2canvas ne peint pas le contenu des
 * <img src="data:image/svg+xml;base64,...">  positionnés/recadrés en CSS
 * (élément capturé mais pixels finaux vides, sans erreur) — un raster PNG à
 * plat, sans SVG ni recadrage CSS, contourne complètement ce problème.
 */
export function rasterizeLogoToPngDataUri(svgContent: string, cropX: number, cropY: number, zoom: number, size: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const naturalW = img.naturalWidth || size;
      const naturalH = img.naturalHeight || size;
      const baseScale = Math.min(size / naturalW, size / naturalH);
      const scale = baseScale * zoom;
      const w = naturalW * scale;
      const h = naturalH * scale;
      const left = (size - w) / 2 - cropX * size;
      const top = (size - h) / 2 - cropY * size;

      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas 2D non disponible'));
        return;
      }
      ctx.save();
      ctx.beginPath();
      ctx.rect(0, 0, size, size);
      ctx.clip();
      ctx.drawImage(img, left, top, w, h);
      ctx.restore();
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Échec du chargement du logo'));
    img.src = toSvgDataUri(svgContent);
  });
}
